<div class="top">
    <div class="header">
        <h1 align="center">Customer Comments</h1>
    </div>

    <div class="testmonial-bg">
        <div class="testimonial_container">
            <div class="testmonial_info">
                <h3 class="testimonial_title text-center"> What our customers say About us </h3>

                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-lg-6 col-xl-4 test_one_card">
                              <div class="card">
                                  <div class="card-body">
                                    <h5 class="text-center">
                                        <i class="fa fa-quote-left" aria-hidden="true" style="color: #FBBC5D;"></i>
                                    </h5>
                                    <p class="test_para">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                                        classical Latin.</p>
                                    <hr class="test_hr">
                                    <div id="uicon">
                                        <img src="assets\Images\Rectangle 50.png" width="70" height="70" class="rounded-circle"
                                            style="display: block; margin-left: auto; margin-right: auto; margin-bottom: 5px;">
                                    </div>
                                    <h5 class="text-center test_name">Gopinath Appam</h5>
                                  </div>
                              </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-xl-4 test_two_card">
                              <div class="card">
                                  <div class="card-body">
                                    <h5 class="text-center">
                                        <i class="fa fa-quote-left" aria-hidden="true" style="color: #FBBC5D;"></i>
                                    </h5>
                                    <p class="test_para">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                                        classical Latin.</p>
                                    <hr class="test_hr">
                                    <div id="uicon">
                                        <img src="assets\Images\Rectangle 50.png" width="70" height="70" class="rounded-circle"
                                            style="display: block; margin-left: auto; margin-right: auto; margin-bottom: 5px;">
                                    </div>
                                    <h5 class="text-center test_name">Gopinath Appam</h5>
                                  </div>
                              </div>
                        </div>
                        <div class="col-md-6 col-lg-6 col-xl-4 test_three_card">
                              <div class="card">
                                  <div class="card-body">
                                    <h5 class="text-center">
                                        <i class="fa fa-quote-left" aria-hidden="true" style="color: #FBBC5D;"></i>
                                    </h5>
                                    <p class="test_para">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                                        classical Latin.</p>
                                    <hr class="test_hr">
                                    <div id="uicon">
                                        <img src="assets\Images\Rectangle 50.png" width="70" height="70" class="rounded-circle"
                                            style="display: block; margin-left: auto; margin-right: auto; margin-bottom: 5px;">
                                    </div>
                                    <h5 class="text-center test_name">Gopinath Appam</h5>
                                  </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

        <app-footer></app-footer>
   </div>